import { slicedToArray as _slicedToArray } from '../../../../_virtual/_rollupPluginBabelHelpers.mjs';
import { jsx, jsxs } from 'react/jsx-runtime';
import { DefaultLoader, H7Bold } from '@moim/common';
import React__default from 'react';
import { getLocalYYYYMMDD, getLocalHHMMperiod } from '../../utils.mjs';
import { useCalendarContext } from '../context/calendarProvider.mjs';
import { useCalendarEventContext } from '../context/eventProvider.mjs';
import { BodyWrapper, ScrollContainer, EmptyEventWrapper, SectionContainer, SectionTitle, SectionBody } from './styled.mjs';

var BodyContainer = function BodyContainer(_ref) {
  var hasTemplate = _ref.hasTemplate,
    EmptyEventElement = _ref.EmptyEventElement,
    LoadingElement = _ref.LoadingElement,
    EventItemContainerCreator = _ref.EventItemContainerCreator;
  var _a;
  var refScroll = React__default.useRef(null);
  var _useCalendarContext = useCalendarContext(),
    calendarMode = _useCalendarContext.calendarMode,
    selectedDateValue = _useCalendarContext.selectedDateValue;
  var _useCalendarEventCont = useCalendarEventContext(),
    initFetched = _useCalendarEventCont.initFetched,
    isFetching = _useCalendarEventCont.isFetching,
    events = _useCalendarEventCont.events,
    overviewEventOnCalendar = _useCalendarEventCont.overviewEventOnCalendar;
  var selectedDate = React__default.useMemo(function () {
    var date = new Date(selectedDateValue);
    switch (calendarMode) {
      case "day":
      case "week":
      case "month":
        return getLocalYYYYMMDD(date);
    }
  }, [calendarMode, selectedDateValue]);
  var groupedEvents = React__default.useMemo(function () {
    if (!overviewEventOnCalendar[selectedDate]) return {};
    // 이벤트들을 "HH:MM" 키로 그룹화합니다.
    return overviewEventOnCalendar[selectedDate].reduce(function (acc, eventId) {
      var event = events[eventId];
      var date = new Date(event.startAt);
      var startTime = getLocalHHMMperiod(date);
      if (!acc[startTime]) {
        acc[startTime] = [];
      }
      acc[startTime].push(eventId);
      return acc;
    }, {});
  }, [overviewEventOnCalendar, selectedDate, events]);
  return jsx(BodyWrapper, {
    children: jsx(ScrollContainer, {
      ref: refScroll,
      children: isFetching || !initFetched ? jsx(EmptyEventWrapper, {
        children: LoadingElement !== null && LoadingElement !== void 0 ? LoadingElement : jsx(DefaultLoader, {})
      }) : !((_a = overviewEventOnCalendar[selectedDate]) === null || _a === void 0 ? void 0 : _a.length) ? jsx(EmptyEventWrapper, {
        children: EmptyEventElement !== null && EmptyEventElement !== void 0 ? EmptyEventElement : "🌴 EMPTY EVENT"
      }) : Object.entries(groupedEvents).map(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 2),
          startTime = _ref3[0],
          eventIds = _ref3[1];
        return jsxs(SectionContainer, {
          children: [jsx(SectionTitle, {
            children: jsx(H7Bold, {
              children: startTime
            })
          }), jsx(SectionBody, {
            children: eventIds.map(function (eventId) {
              return EventItemContainerCreator({
                event: events[eventId],
                hasTemplate: hasTemplate
              });
            })
          })]
        }, "section_".concat(selectedDate, "_").concat(startTime));
      })
    })
  });
};

export { BodyContainer };
